module.exports = __webpack_public_path__ + "img/collection-memoireRingsGrowingMemoires.d127140.jpg";